import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/footer/grand-cahors.png")